export const environment = {
  apiUrl: "https://stage-api.bukiglobal.com/",
  appUrl: "https://admin.bukiglobal.com",
  BaseUrl: "https://media.bukiglobal.com/",
  publicKey: "97852201:publickey_r8oTwfeKXs5e1Mo2fmONvJ7fbAawZuH8uKRL4WsBEZU17",

  production: true,

  firebase: {
    apiKey: "AIzaSyCyttSvlXpJWPsGLBgfxsnKKK95os2-HfQ",
    authDomain: "buki-8addc.firebaseapp.com",
    projectId: "buki-8addc",
    storageBucket: "buki-8addc.appspot.com",
    messagingSenderId: "705846407545",
    appId: "1:705846407545:web:e249fad1c176f0b6343fa8",
    measurementId: "G-6NNWSP95DE",
  },

  appleClientId: "KH6CQY84Z5",
  googlePrivateKey: "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",
  mapsAPIKey: "AIzaSyCyttSvlXpJWPsGLBgfxsnKKK95os2-HfQ",
  googleClientId:
    "705846407545-6lc94nk06the6udh2ul82cfo090dh6ii.apps.googleusercontent.com",
};